import { render, staticRenderFns } from "./insertEdit.vue?vue&type=template&id=d8cb995c"
import script from "./insertEdit.vue?vue&type=script&lang=js"
export * from "./insertEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports